var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ProjectSummary',{attrs:{"project-exid":_vm.projectExid,"company-id":_vm.companyId,"company-name":_vm.companyName,"zoho-id":_vm.zohoId,"inline":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }